// extracted by mini-css-extract-plugin
module.exports = {"svg":"SvgIcon_svg__iptUJ"};